import { Box, Flex, Input, Spinner } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'

import { Tooltip } from './Tooltip'

export default function DateBlurInput({
  initialValue,
  onSave,
  ariaLabel
}: {
  initialValue: string
  onSave: (value: string) => Promise<void> | void
  ariaLabel?: string
}) {
  const [value, setValue] = useState(initialValue)
  const [saving, setSaving] = useState(false)
  const savedRef = useRef(initialValue)

  useEffect(() => {
    setValue(initialValue)
    savedRef.current = initialValue
  }, [initialValue])

  const handleBlur = async () => {
    if (value === savedRef.current) return
    setSaving(true)
    try {
      await onSave(value)
      // Only mark as saved once persistence succeeds, so a failed save retries on the next blur.
      savedRef.current = value
    } catch {
      // Keep savedRef unchanged to allow retry; the caller surfaces the error toast.
    } finally {
      setSaving(false)
    }
  }

  return (
    <Flex alignItems="center" gap={1} w="130px">
      <Input
        type="date"
        size="xs"
        w="125px"
        aria-label={ariaLabel}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleBlur}
        isDisabled={saving}
      />
      <Box w="14px" flexShrink={0}>
        {saving && (
          <Tooltip label="Salvando..." isOpen>
            <Spinner size="xs" color="blue.500" />
          </Tooltip>
        )}
      </Box>
    </Flex>
  )
}
